export function isObject(o) {
  return Object.prototype.toString.call(o) === "[object Object]";
}
export function deepFindLog(element, baseAttribute, extraAttribute) {
  let findBaselog = true;
  let logs = [];
  let p = element;

  while (!!p && p !== document) {
    if (!(p instanceof HTMLElement || p instanceof SVGElement)) {
      p = p.parentNode;
      continue;
    }

    const attributeValue = p.getAttribute(findBaselog ? baseAttribute : extraAttribute) || "";
    let obj;

    try {
      obj = JSON.parse(attributeValue);

      if (isObject(obj)) {
        logs.push(obj);

        if (findBaselog) {
          findBaselog = false;
          continue;
        }
      }
    } catch (error) {}

    p = p.parentNode;
  }

  if (logs.length > 0) {
    return logs;
  }

  return null;
}
export function isIntersecting(e) {
  return e.isIntersecting || e.intersectionRatio > 0;
}
export function now() {
  const n = window.performance && performance.now && performance.now();
  return n || Date.now();
}
export function noop() {}
export function fixIosClick() {
  for (let i = 0, nodes = document.body.childNodes; i < nodes.length; i++) {
    const node = nodes[i];

    if (node instanceof Element && node.nodeType === 1 && !node["onclick"]) {
      node["onclick"] = noop;
    }
  }
}
export function getAttrFrom(e, key) {
  return e.target && e.target.getAttribute(key);
}
export function isBrowser() {
  return typeof window !== "undefined" && typeof window.document !== "undefined";
}
export function findExtraLog(element, extraAttribute = "data-log-extra") {
  const logs = [];
  let p = element;

  while (!!p && p !== document) {
    if (!(p instanceof HTMLElement || p instanceof SVGElement)) {
      p = p.parentNode;
      continue;
    }

    const attributeValue = p.getAttribute(extraAttribute) || "";

    try {
      if (attributeValue) {
        const extraLog = JSON.parse(attributeValue);
        logs.unshift(extraLog);
      }
    } catch (error) {
      console.warn("parse json in data-log-extra");
      console.error(error);
    }

    p = p.parentNode;
  }

  return logs.reduce((acc, curr) => Object.assign(Object.assign({}, acc), curr), {});
}
export function getPathByEle(element) {
  if (!element) {
    return "";
  }

  if (element.id !== "") return `#${element.id}`;
  if (element === document.body) return "body";
  let ix = 0;

  if (!element.parentNode) {
    return "html";
  }

  const siblings = element.parentNode.childNodes;

  for (let i = 0, l = siblings.length; i < l; i++) {
    let sibling = siblings[i];
    if (sibling === element) return `${getPathByEle(element.parentNode)}/${element.tagName.toLowerCase()}${ix > 0 ? `[${ix + 1}]` : ``}`;

    if (sibling.nodeType === 1 && sibling.tagName === element.tagName) {
      ix++;
    }
  }

  return element.tagName.toLowerCase();
}
export function isHtmlOrSvg(node) {
  if (node === null) {
    return false;
  }

  return node.nodeType === 1 && (node instanceof HTMLElement || node instanceof SVGAElement);
}
export function getClickPositionParams(e, logs = []) {
  const tgt = e.target;

  if (!window || !isHtmlOrSvg(tgt) || e.type !== "click") {
    return;
  }

  try {
    const {
      x,
      y
    } = e;
    const {
      left,
      top
    } = tgt.getBoundingClientRect();
    const path = getPathByEle(tgt);
    return {
      ele_x: ~~(x - left),
      ele_y: ~~(y - top),
      ele_path: path,
      dw: window.innerWidth,
      dh: window.innerHeight
    };
  } catch (err) {
    const error_type = "get_click_position_error";
    const info = Object.assign({}, ...[...logs].reverse());
    const tags = {
      error_type
    };
    console.error(err);

    try {
      if (window.Slardar) {
        window.Slardar("Sentry", Sentry => {
          Sentry.withScope(scope => {
            scope.setTags(tags);
            scope.setExtras(info);
            Sentry.captureException(err);
          });
        });
      }
    } catch (innerErr) {
      console.error("Sentry Error!");
    }
  }

  return null;
}
export function isUndefined(a) {
  return typeof a === 'undefined';
}
export function debounce(func, wait, immediate) {
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;

      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  }

  ;

  var debounced = function () {
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);

    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  return debounced;
}
;